'use client';

import { renderAppIcon } from '@/components/icons/app-icon-registry';
import { Button } from '@/components/ui/actions/button';
import { cn } from '@/lib/ui/utils';
import { CmsLoginDialogBody } from './cms-login-dialog-body';
import type { CmsLoginDialogModel } from './cms-login-dialog-model';
import styles from './cms-login-dialog.module.css';

export function CmsLoginWorkspacePreparingOverlay({
  model,
  title,
}: {
  model: CmsLoginDialogModel;
  title: string;
}) {
  const descriptionId = 'site-runtime-workspace-auth-return-description';
  const titleId = 'site-runtime-workspace-auth-return-title';

  return (
    <div
      className={styles.authReturnOverlay}
      data-site-runtime-workspace-auth-return-overlay=""
    >
      <div aria-hidden="true" className="fixed inset-0 z-[9998] bg-black/50" />
      <div
        className={cn(
          'fixed inset-0 z-[9999] flex items-center justify-center',
          styles.positioner
        )}
      >
        <dialog
          aria-describedby={descriptionId}
          aria-labelledby={titleId}
          aria-modal="true"
          className={cn(
            'cms-theme cms-theme-standard relative grid',
            styles.dialogContent
          )}
          open
        >
          <p className="sr-only" id={descriptionId}>
            {model.description}
          </p>
          <CmsLoginDialogBody
            googleButtonLoading
            model={model}
            phase="preparing-workspace"
            renderAuthFlow={() => (
              <div className={styles.buttonShell}>
                <Button
                  className={cn('w-full', styles.googleButton)}
                  disabled
                  size="lg"
                  type="button"
                  variant="default"
                >
                  {renderAppIcon({
                    name: 'loader2',
                    className: 'mr-2 size-4 animate-spin',
                  })}
                  <span>{model.googleButtonLabel}</span>
                </Button>
              </div>
            )}
            title={
              <h2 className={styles.title} id={titleId}>
                {title}
              </h2>
            }
          />
        </dialog>
      </div>
    </div>
  );
}
